
import { defineComponent } from 'vue';
import DarkModeSelector from './DarkModeSelector.vue'
import LanguageSelector from './LanguageSelector.vue'

export default defineComponent({
  name: 'NavBar',
  components: {
    DarkModeSelector,
    LanguageSelector
  },
  data: () => ({
    darkMode: false
  }),
  async mounted() {
    const theme = document?.querySelector('html')?.getAttribute('data-theme') || 'light'
    theme === 'light' ? this.darkMode = false : this.darkMode = true
  },
  computed: {
    isDarkMode() {
      return this.darkMode
    }
  }
})
